// src/components/Footer.js
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="container-fluid text-light" style={{ backgroundColor: "#081428", paddingTop: 40, paddingBottom: 40 }}>
      <div className="container">
        <div className="row gy-5">
          {/* Logo and Info */}
          <div className="col-md-4">
            {/* <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/fa762d5fc55680b0d13de50fa0dd6514161b6138?width=155"
              alt="ECL Logo"
              className="img-fluid"
              style={{ height: 48 }}
            /> */}
            {/* <p className="mt-3" style={{ color: "#cfd9e6" }}>
              ECL is an ISO-certified Professional Services company. We deliver IT solutions such as Hybrid Cloud Infrastructure, Business Process Automation,  and Recovery, and Cybersecurity.
            </p> */}
            <div>
              <Link to="/contactUsPage" className="lets-talk-link">Let’s Talk</Link> <br />
              <a href="mailto:info@ecl-global.com"><i className="bi bi-envelope"></i> info@ecl-global.com</a>
            </div>
           
          </div>

          {/* Ghana + Liberia Offices */}
          <div className="col-md-3">
            <h5>Ghana 🇬🇭</h5>
            <p><i className="bi bi-telephone"></i> +233 50 604 5005</p>
            <a  href="mailto:info@ecl-global.com"><i className="bi bi-envelope"></i> info@ecl-global.com</a>
            <p><i className="bi bi-geo-alt"></i> Aviation Rd - Community 3, Tema, Greater Accra, Ghana</p>

            <h5 className="mt-4">Liberia 🇱🇷</h5>
            <p><i className="bi bi-telephone"></i> +231 55 571 9281</p>
            <a href="mailto:info@ecl-global.com"><i className="bi bi-envelope"></i> info@ecl-global.com</a>
            <p><i className="bi bi-geo-alt"></i> Cheeseman Street, Airfield Community, Opposite Starz University, Sinkor, Monrovia</p>
          </div>

          {/* Useful Links */}
          <div className="col-md-2">
            <h5>Useful Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-decoration-none">Home</Link></li>
              <li><Link to="/AboutUs" className="text-decoration-none">About Us</Link></li>
              <li><Link to="/caseStudies" className="text-decoration-none">Case Studies</Link></li>
              <li><Link to="/contactUsPage" className="text-decoration-none">Contact Us</Link></li>
              <li><Link to="/privacy" className="text-decoration-none">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Our Solutions */}
          <div className="col-md-3">
            <h5>Our Solutions</h5>
            <ul className="list-unstyled">
              <li><Link to="/services/6" className="text-decoration-none">Hybrid Cloud Infrastructure</Link></li>
              <li><Link to="/services/4" className="text-decoration-none">Cybersecurity</Link></li>
              <li><Link to="/services/2" className="text-decoration-none">Cyber Resilience</Link></li>
              <li><Link to="/services/3" className="text-decoration-none">Business Process Automation (BPA)</Link></li>
              <li><Link to="/services/5" className="text-decoration-none">Product Development</Link></li>
              <li><Link to="/services" className="text-decoration-none">smartCover</Link></li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom mt-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div className="social-icons mb-3 mb-md-0">
              <a href="https://web.facebook.com/EnterpriseComputingLtd" aria-label="Facebook"><i className="bi bi-facebook"></i></a>
              <a href="https://www.linkedin.com/company/enterprise-computing-ltd/posts/?feedView=all" aria-label="LinkedIn"><i className="bi bi-linkedin"></i></a>
              <a href="https://x.com/entcomputing" aria-label="Twitter"><i className="bi bi-twitter"></i></a>
              <a href="https://www.instagram.com/enterprisecomputingltd" aria-label="Instagram"><i className="bi bi-instagram"></i></a>
              <a href="https://www.youtube.com/@EnterpriseComputingLtd./shorts" aria-label="YouTube"><i className="bi bi-youtube"></i></a>
            </div>

            <p className="mb-0 text-center text-md-end" style={{ color: "#aaa" }}>
              © {new Date().getFullYear()} <a href="#" style={{ color: "#00aaff", textDecoration: "none" }}>Enterprise Computing Limited</a>. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
